export default __webpack_public_path__ + "static/media/plus-green.dfc9708c.svg";